import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

const viewport = { once: true, margin: "-60px" };

export const Reveal = ({ children, className = "", delay = 0, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      transition={{ delay }}
    >
      {children}
    </MotionTag>
  );
};

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] uppercase text-blue-600 ${className}`}
  >
    <span className="w-1.5 h-1.5 rounded-full bg-blue-600" />
    {children}
  </span>
);

export default Reveal;
